import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavbarService } from '../shared/services/navbar.service';
import { UserService } from '../shared/services/user.service';
import { Utils } from '../shared/utils/utils';
import { IWGSharedService } from '../shared/services/shared.service';
import { AssignmentDialogService } from '../shared/services/assignment-dialog.service';
import { QuotesDialogComponent } from '../quotes/quotes-dialog/quotes-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-assignments',
  templateUrl: './assignments.component.html',
  styleUrls: ['./assignments.component.scss']
})

export class AssignmentsComponent implements OnInit {

  activeiconcolor = 'assignments';

  selectedService = 1;
  selectedServiceName: string;
  ShowEOREstimator = false;
  showCompliance = false;
  assignmentLabel = '';
  assignmentLabelPlural = '';
  ShowQuotesButton = false;
  sub: any;
  state: any = {};

  EORDisabled = false;
  ComplianceDisabled = false;
  AORDisabled = false;

  ShowEORQuotes = true;
  ShowComplianceQuotes = true;
  ShowAORQuotes = true;
    showFooter = true;
    embedStatus = "notembed";  

    constructor(public router: Router, private utils: Utils, public userService: UserService, private assignmentDialogService: AssignmentDialogService,
        public nav: NavbarService, private route: ActivatedRoute, public sharedService: IWGSharedService, public dialog: MatDialog) {
      this.router.routeReuseStrategy.shouldReuseRoute = (): boolean => {
        return false;
      };
    }

  ngOnInit(): void { 
      var isEmbed = this.sharedService.getIsEmbed();
      if (isEmbed === true) {
          this.nav.show(isEmbed);    
          this.embedStatus = "embed";
          history.pushState(null, null, null);
          window.addEventListener('popstate', () => {
              history.pushState(null, null, null);
          });
          this.showFooter = false;
      }
      else {
          this.nav.show();
          this.nav.setActiveMenu('services');
          this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'services'});
          this.showFooter = true;
      }
      


    this.state = {limit: 25, page: 1, service: 1, global_scope: 1, country: -1, state: -1};
    this.route.queryParams.subscribe(params => {
      if (params) {       
        
        this.state = Object.assign({}, this.state, (params));
        if (!this.state.service) {
          this.state.service = 1;
        }
        if (params.start) {
          this.state.start = new Date(params.start);
        }
        if (params.end) {
          this.state.end = new Date(params.end);
        }
      }
    });
    this.showCompliance = this.userService.getEvaluateButtonDisabled();
    this.selectedService = +this.state.service;    
    this.selectedServiceName = this.utils.getServiceName(this.selectedService);
    this.ShowEOREstimator = this.userService.getShowEOREstimator();
   
    if (this.userService.getEOREstimatorAccess()) {
      this.ShowEOREstimator = true;
    } else {
      this.ShowEOREstimator = false;
    }
    if(this.userService.getRole() == 'Worker') {
      this.ShowEORQuotes = false;
      this.ShowComplianceQuotes = false;
      this.ShowAORQuotes = false;
    }
  var role = this.userService.getRole();
  if (role == 'Worker') {
    this.ShowEOREstimator = false;
  }

    if (this.selectedServiceName === 'Employer of Record') {
        this.assignmentLabel = 'Assignment';
    } else if (this.selectedServiceName === 'Agent of Record') {
        this.assignmentLabel = 'Engagement';
    } else if (this.selectedServiceName === 'Compliance') {
        this.assignmentLabel = 'Evaluation';
    }
    this.assignmentLabelPlural = this.assignmentLabel + 's';

    this.ShowQuotesButton = !this.userService.getNewQuotesDisabled();

    this.EORDisabled = this.userService.getEORDisabled();
    this.ComplianceDisabled = this.userService.getComplianceDisabled();
    this.AORDisabled = this.userService.getAORDisabled();
  }

  showQuoteEstimator = (ev) => {
      this.router.navigate(["/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c"], 
        {queryParams:{service: this.state.service, global_scope: this.state.service}});

    }
    showAssignmentDialog = (ev, quoteId, serviceId) => {
        this.assignmentDialogService.show(ev, null, quoteId, null, null, serviceId);
    }
    ShowQuoteDialog_embed = (ev) => {
        this.displayQuoteDialog(ev);
    }

    displayQuoteDialog = (ev) => {
        this.sharedService.isBlurredBg.next(true);
        const dialogRef = this.dialog.open(QuotesDialogComponent, {
            panelClass: 'iwg-form-dialogfull',
            autoFocus: false,
            data: { existingQuote: null }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.sharedService.isBlurredBg.next(false);
        });
    }

}
